import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, computed } from 'vue';
import { toDot } from '@/common/utils/Util';
const __default__ = {
  name: 'appg-plain-text'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    modelValue: String,
    group: {
      type: Boolean,
      description: 'Whether input is an input group (manual override in special cases)'
    },
    valid: {
      type: Boolean,
      description: 'Whether is valid',
      default: true
    },
    alternative: {
      type: Boolean,
      description: 'Whether input is of alternative layout'
    },
    label: {
      type: String,
      description: 'Input label (text before input)'
    },
    labelClasses: {
      type: String,
      description: 'Input label css classes',
      default: 'form-control-label'
    },
    inputClasses: {
      type: String,
      description: 'Input css classes'
    },
    inputGroupClasses: {
      type: String,
      description: 'Input group css classes'
    },
    appendIcon: {
      type: String,
      description: 'Append icon (right)'
    },
    prependIcon: {
      type: String,
      description: 'Prepend icon (left)'
    },
    isFormGroup: {
      type: Boolean,
      description: 'Whether is form-group className',
      default: true
    },
    isFormInline: {
      type: Boolean,
      description: 'form-inline className'
    },
    inlineHeadText: {
      type: String,
      description: 'inline head text'
    },
    inlineTailText: {
      type: String,
      description: 'inline tail text'
    },
    isInlineBlock: {
      type: Boolean,
      description: 'display inline-block'
    },
    span: {
      type: String,
      description: 'small text',
      default: ''
    },
    _class: {
      type: String,
      default: ''
    },
    isDotted: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  setup(__props, {
    emit: __emit
  }) {
    const inheritAttrs = ref(false);
    const props = __props;
    const emits = __emit;
    const focused = ref(false);
    const slotData = () => computed(() => {
      return {
        focused: this.focused,
        inValidMessage: this.inValidMessage,
        ...this.listeners
      };
    });
    const hasIcon = () => computed(() => {
      const {
        append,
        prepend
      } = this.$slots;
      return append !== undefined || prepend !== undefined || this.appendIcon !== undefined || this.prependIcon !== undefined || this.group;
    });
    function updateValue(evt) {
      const value = evt.target.value;
      emits('update:modelValue', value);
    }
    function onFocus(evt) {
      this.focused = true;
      emits('focus', evt);
    }
    function onBlur(evt) {
      this.focused = false;
      emits('blur', evt);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([[{
          'form-group': __props.isFormGroup,
          'd-inline-block': __props.isInlineBlock
        }, __props._class], "mb-4"])
      }, [_renderSlot(_ctx.$slots, "label", {}, () => [__props.label ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass([__props.labelClasses, "d-flex"])
      }, [_createElementVNode("h6", null, _toDisplayString(__props.label), 1)], 2)) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "span", {}, () => [__props.span ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(__props.labelClasses),
        style: {
          "font-size": "1rem"
        }
      }, _toDisplayString(__props.span), 3)) : _createCommentVNode("", true)])], 2);
    };
  }
});